import "./App.css";
import React, { Suspense ,useEffect} from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import CustomLoader  from "./overlays/CustomLoader";
///////////////
////images/////
///////////////

import ConcentricCircleImage from './images/ConcentricCircle.png'
import GridImage from './images/Grid.png'
import RainbowWavesImage from './images/RainbowWaves.png'
import PolygonImage from './images/Polygon.png'
import DwlSphereImage from './images/DwlSphere.png'
import GradientFireImage from './images/GradientFire.png'
import AnimeWaterImage from './images/AnimeWater.png'
import ImageParticleImage from './images/ImageParticle.png'
import MoirePatternImage from './images/MoirePattern.png'
import MatCapsImage from './images/MatCaps.png'
import DistortedSphereImage from './images/DistortedSphere.png'
import DistortedParticlePlaneImage from './images/DistortedParticlePlane.png'
import BakedModelImage from './images/BakedModel.png'
///////////////
//components///
///////////////
const ImageParticle = React.lazy(() =>import("./components/ImageParticle"));
const AnimeWater = React.lazy(() =>import("./components/AnimeWater"));
const ConcentricCircle = React.lazy(() =>import("./components/ConcentricCircle"));
const Grid = React.lazy(() => import("./components/Grid"));
const RainbowWaves = React.lazy(() => import("./components/RainbowWaves"));
const Polygon = React.lazy(() => import("./components/Polygon"));
const DwlSphere = React.lazy(() => import("./components/DwlSphere"));
const GradientFire = React.lazy(() =>import("./components/GradientFire"));
const MoirePattern = React.lazy(() =>import("./components/MoirePattern"));
const MatCaps = React.lazy(() =>import("./components/MatCaps"));
const DistortedSphere = React.lazy(() =>import("./components/DistortedSphere"));
const DistortedParticlePlane = React.lazy(() =>import("./components/DistortedParticlePlane"));
const BakedModel = React.lazy(() =>import("./components/BakedModel"));

const linkmap = [ 
  {
    path: "/BakedModel",
    Component: BakedModel,
    name: "Baked Model",
    inspiration: null,
    image: BakedModelImage,
  },
  {
    path: "/DistortedParticlePlane",
    Component: DistortedParticlePlane,
    name: "Distorted Particle Plane",
    inspiration: 'https://www.behance.net/gallery/54100633/Devx-Experiments-DDD2017?tracking_source=search_projects_recommended%7Cwebgl',
    image: DistortedParticlePlaneImage,
  },
  {
    path: "/DistortedSphere",
    Component: DistortedSphere,
    name: "Distorted Sphere",
    inspiration: 'https://gist.github.com/patriciogonzalezvivo/670c22f3966e662d2f83',
    image: DistortedSphereImage,
  },
  {
    path: "/MatCaps",
    Component: MatCaps,
    name: "MatCaps",
    inspiration: null,
    image: MatCapsImage,
  },
  {
    path: "/MoirePattern",
    Component: MoirePattern,
    name: "Moiré pattern",
    inspiration: null,
    image: MoirePatternImage,
  },
  {
    path: "/ImageParticle",
    Component: ImageParticle,
    name: "Image Particle",
    inspiration: null,
    image: ImageParticleImage,
  },
  {
    path: "/AnimeWater",
    Component: AnimeWater,
    name: "Anime Water",
    inspiration: "https://twitter.com/FarrukhAbdur/status/1304430019528269827",
    image: AnimeWaterImage,
  },
  {
    path: "/GradientFire",
    Component: GradientFire,
    name: "Gradient Fire",
    inspiration: "https://twitter.com/minionsart/status/964257071423283200",
    image: GradientFireImage,
  },
  {
    path: "/DwlSphere",
    Component: DwlSphere,
    name: "Dwl Sphere",
    inspiration: "https://dwl.media/",
    image: DwlSphereImage,
  },
  {
    path: "/ConcentricCircle",
    Component: ConcentricCircle,
    name: "ConcentricCircle",
    inspiration: "https://twitter.com/marioecg/status/1318360618043428870",
    image: ConcentricCircleImage,
  },
  {
    path: "/RainbowWaves",
    Component: RainbowWaves,
    name: "Rainbow Waves",
    inspiration: "https://twitter.com/ilithya_net/status/1319048032126705671",
    image: RainbowWavesImage,
  },
  {
    path: "/Polygon",
    Component: Polygon,
    name: "Polygons",
    inspiration: null,
    image: PolygonImage,
  },
  {
    path: "/Grid",
    Component: Grid,
    name: "Grid",
    inspiration: null,
    image: GridImage,
  },
];

function App() {  
  useEffect(() => {
    document.title = "WebGLfun"    
    return ()=>{
      document.title = "WebGlfun"    
    }
  }, [])
  return (
    <>
      <Router>
        <header>
          <Link to={process.env.PUBLIC_URL}>menu</Link>
        </header>
        <Switch>
          <Route exact path={process.env.PUBLIC_URL}>
            <Suspense fallback={<CustomLoader/>}>
              <div className="tagline">WebGL is Fun</div>
              <div className="card-wrapper">
                {linkmap.map((c, i) => (
                  <Link to={process.env.PUBLIC_URL+c.path} key={i}>
                    <div className="card">
                      <h5>{c.name}</h5>
                      <img src={c.image} alt={c.name} />
                    </div>
                  </Link>
                ))}
              </div>
            </Suspense>
          </Route>
          {linkmap.map((c) => (
            <Route exact path={process.env.PUBLIC_URL+c.path}>              
              <Suspense fallback={<CustomLoader/>}>
                <c.Component inspiration={c.inspiration} />
              </Suspense>
            </Route>
          ))}
        </Switch>
      </Router>
    </>
  );
}

export default App;
